export enum SIGNIN_API_CLIENT_ERROR_CODES {
    DEFAULT = 'an_error_has_occurred_please_try_again_later_406',
    RATE_LIMIT_EXCEEDED = 'rate_limit_exceeded',
    INVALID_CREDENTIALS = 'invalid_credentials',
    INVALID_EMAIL_AND_OR_PASSWORD = 'invalid_email_and_or_password',
    ACCOUNT_BLOCKED = 'account_blocked',
    USER_ALREADY_LOGGED_IN = 'user_already_logged_in',
}

export const SIGNIN_ERROR_STATUS_CODES = [401, 403, 406, 429];
